// import external dependencies
import 'jquery';
import barbaInit from './barbainit';
import AOS from 'aos';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import postTypeArchiveBusiness from './routes/postTypeArchiveBusiness';
import singleEvent from './routes/singleEvent';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  postTypeArchiveBusiness,
  singleEvent,
});

// Load Events
jQuery(document).ready(() => {
  AOS.init({
    offset: 150, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 800, // values from 0 to 3000, with step 50ms

  });
  routes.loadEvents();
  barbaInit(routes);
});



// WEBPACK FOOTER //
// ./scripts/main.js